import AOS from 'aos';
import cookieConsent from './cookie_consent'

// Stimulus
import 'controllers/landing'

import * as Turbo from "@hotwired/turbo"

global.$ = $

document.addEventListener('turbo:load', () => {
  AOS.init({
    disable: 'mobile',
    duration: 600,
    once: true,
    disableMutationObserver: true,
  })

  cookieConsent()
})

document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('.aos-init').forEach((el) => el.classList.remove('aos-init'))
  document.querySelectorAll('.aos-animate').forEach((el) => el.classList.remove('aos-animate'))
})
